import { QueryClient } from "@tanstack/react-query";

// Single shared server-state cache (docs/09-frontend-surface.md §6). Class-A
// records (transcripts, traces, answers) are immutable after creation, so
// reads can stay fresh for a long window and corrections arrive as new rows
// surfaced via SSE/refetch rather than in-place mutation of a cached record.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Conservative default; immutable Class-A reads can override upward.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
